<template>
  <div id="Header">
    <div class="flex logo_box">
      <a href="/" class="logo"></a>
      {{ $t('enum.sellerCenter') }}
    </div>
    <div class="flex user_badge">
      <el-tooltip class="icons-email" effect="dark" :content="$t('menu.messages')" placement="bottom">
        <a class="" target="_blank" :href="wyimLink">&nbsp;</a>
      </el-tooltip>
      <router-link class="badge" :to="{ path: '/messages' }"><sup v-if="$store.state.msgCounts.TotalCount > 0">{{ $store.state.msgCounts.TotalCount > 99 ? 99 + "+" : $store.state.msgCounts.TotalCount }}</sup></router-link>
      <el-tooltip class="blacklist-icon" effect="dark" :content="$t('menu.blacklist')" placement="bottom">
        <router-link :to="{ path: '/blacklist' }"></router-link>
      </el-tooltip>
      <el-dropdown class="headerUser">
        <div class="el-dropdown-link">
          <router-link :to="{ path: '/store' }" class="user_box">
            <el-avatar class="user_img" :src="$store.state.UserDetail.StoreLogo ? $store.state.UserDetail.StoreLogo + $store.state.thumbnail : ($store.state.UserDetail.HeadPortrait ? $store.state.UserDetail.HeadPortrait + $store.state.thumbnail : '')">
            </el-avatar>
            <div class="user_name">{{ $store.state.UserDetail.StoreName ? $store.state.UserDetail.StoreName : ($store.state.UserDetail.NickName ? $store.state.UserDetail.NickName : '') }}</div>
            <!-- NickName -->
          </router-link>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="Logout" style="display:flex;" class="color_333"><span class="Logout"></span> {{ $t("button.logout") }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <change-lang></change-lang>
    </div>
  </div>
</template>

<script>
import changeLang from '@/components/change-lang'
export default {
  name: 'headerNav',
  components: { changeLang },
  data() {
    return {
      wyimLink: `${this.$store.getters.CHAT('admin')}`,
      Counts: {},//各类目数
    }
  },
  created() {
  },
  mounted() {
    // let that = this;
    this.$store.dispatch("msgCounts");
    // that.$get('NotificationCount')
    //   .then((res) => {
    //     if (res.result) {
    //       that.Counts = res.data;
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  },
  methods: {
    Logout() {
      this.$store.dispatch("Logout");
      //console.log(123123);
      // let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.VUE_APP_DOMAIN;
      // this.$cookie.delete('Card_page_source');
      // //登录后如获取不到用户信息去除以下domain
      // this.$cookie.delete('cardUser', { domain });
      // this.$cookie.delete('Card_Seller_UserDetail');
      // this.$cookie.delete('Card_Seller_USERDTL');
      // location.href = '/';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/header.css";

.login {
  line-height: 30px;
  font-weight: 600;
  margin: 0 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue